import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import App from "./App";
import JobDetailPage from "./JobDetailPage";
import CandidatesPage from "./CandidatesPage";
import TemplatePage from "./Standardized-template";
import CandidateDetailPage from "./CandidateDetailPage";
import InterviewersPage from "./InterviewersPage";
import InterviewsPage from "./InterviewsPage";
import Login from "./components/login/login";
import ProtectedRoute from "./components/auth/protectedRoutes";
import RegisterationPage from "./components/login/registration";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MainLayout from "./components/layout/MainLayout";
import theme from "./utils/mui-theme"
import ResetPassword from "./components/login/ResetPassword";
import RegisterFromLink from "./components/login/RegisterFromLink";
import AIInterviewLivePage from "./AIInterviewLivePage";
import RoleRoute, { RequireOrganisation } from "./components/auth/RoleRoute";
import NoOrganisationPage from "./components/login/NoOrganisationPage";
import SettingsPage from "./SettingsPage";
import AuditLogPage from "./AuditLogPage";
import AcceptInvitePage from "./components/login/AcceptInvitePage";
import PricingPage from "./components/subscription/PricingPage";

// Old organisation links open the matching Settings tab, keeping the rest of the query
const SettingsRedirect = ({ tab }) => {
  const params = new URLSearchParams(useLocation().search);
  params.set("tab", tab);
  return <Navigate to={`/settings?${params.toString()}`} replace />;
};

const AppRouter = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<RegisterationPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register-link" element={<RegisterFromLink />} />
          <Route path="/invite" element={<AcceptInvitePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/" element={<ProtectedRoute />}>
            <Route path="/no-organisation" element={<NoOrganisationPage />} />
            <Route element={<RequireOrganisation />}>
              {/* Full width without the side menu: it sits next to the meeting window */}
              <Route path="/interviews/:interviewId/ai-live" element={<AIInterviewLivePage />} />
              <Route element={<MainLayout />}>
                <Route path="/interviews" element={<InterviewsPage />} />
                {/* Panelists see assigned candidates from their interviews */}
                <Route path="/candidate-list/:candidateId" element={<CandidateDetailPage />} />
                {/* Every signed-in person has Settings; each tab checks its own permission */}
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/organisation" element={<SettingsRedirect tab="organisation" />} />
                <Route path="/organisation/team" element={<SettingsRedirect tab="team" />} />
                {/* Stripe returns here after Checkout: /organisation/billing?checkout=success */}
                <Route path="/organisation/billing" element={<SettingsRedirect tab="plan" />} />
                <Route element={<RoleRoute permission="hiring" />}>
                  <Route index element={<App />} />
                  <Route path="/jobs" element={<App />} />
                  <Route path="/jobs/:jobId" element={<JobDetailPage />} />
                  <Route path="/candidates" element={<CandidatesPage />} />
                  <Route path="/interviewers" element={<InterviewersPage />} />
                  <Route path="/jobs/:jobId/candidates" element={<CandidatesPage />} />
                  <Route path="/standardized-template" element={<TemplatePage />} />
                </Route>
                <Route element={<RoleRoute permission="viewAuditLog" />}>
                  <Route path="/organisation/activity" element={<AuditLogPage />} />
                </Route>
                <Route path="/admin/organisations" element={<SettingsRedirect tab="all-organisations" />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default AppRouter;
